import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/img/icon/arrow-circle-right-outline-blue.svg'
import _imports_1 from '@/assets/img/icon/arrow-circle-left-outline-orange.svg'
import _imports_2 from '@/assets/img/icon/bus-outlined-grey.svg'
import _imports_3 from '@/assets/img/icon/bill-outlined-grey.svg'
import _imports_4 from '@/assets/img/icon/notes-outlined-red.svg'
import _imports_5 from '@/assets/img/icon/user-outline-grey.svg'


const _hoisted_1 = {
  key: 0,
  class: "approve-modal"
}
const _hoisted_2 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"16px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = {
  key: 0,
  class: "content"
}
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "Jadwal", -1)
const _hoisted_8 = { class: "text-3xl font-bold" }
const _hoisted_9 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, "Tanggal", -1)
const _hoisted_11 = { class: "text-base font-bold text-grey" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "Kondektur", -1)
const _hoisted_13 = { class: "text-base font-bold text-grey" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, "Supir", -1)
const _hoisted_15 = { class: "text-base font-bold text-grey" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, "Kendaraan", -1)
const _hoisted_17 = { class: "text-base font-bold text-grey" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "Rute Keberangakatan", -1)
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "flex items-center justify-start" }
const _hoisted_22 = {
  key: 0,
  class: "flex items-center mr-3"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  style: {"min-width":"17px","height":"17px"},
  alt: ""
}, null, -1)
const _hoisted_24 = { class: "ml-2 text-sm text-grey" }
const _hoisted_25 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_1,
  style: {"min-width":"17px","height":"17px"},
  alt: ""
}, null, -1)
const _hoisted_27 = { class: "ml-2 text-sm text-grey" }
const _hoisted_28 = { class: "flex justify-between items-center p-4 background-blue-4 rounded-lg mb-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-extrabold" }, "Detail Pendapatan dan pengeluaran", -1)
const _hoisted_30 = { class: "flex items-center" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("View")
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal" }, "Total Rit", -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "text-base font-semibold text-grey" }
const _hoisted_35 = { class: "text-base font-semibold text-grey" }
const _hoisted_36 = { class: "text-base font-semibold text-right" }
const _hoisted_37 = {
  key: 1,
  class: "text-sm text-grey text-center"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal" }, "Detail Pendapatan", -1)
const _hoisted_39 = { class: "flex items-center justify-between border-top-grey-lighten-5 py-3 px-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "mr-2"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-grey" }, "Total Pendapatan Kotor")
], -1)
const _hoisted_41 = { class: "text-base font-semibold" }
const _hoisted_42 = { class: "flex items-center justify-between border-top-grey-lighten-5 py-3 px-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "mr-2"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-grey" }, "Total Pengeluaran")
], -1)
const _hoisted_44 = { class: "flex items-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "mr-2"
}, null, -1)
const _hoisted_46 = { class: "text-base font-semibold text-red" }
const _hoisted_47 = { class: "flex items-center justify-between border-top-grey-lighten-5 py-3 px-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "mr-2"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-semibold text-grey" }, "Total Pendapatan Bersih")
], -1)
const _hoisted_49 = { class: "text-base font-semibold" }
const _hoisted_50 = { class: "flex items-center pt-3" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Approve")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (!_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Dialog, {
          class: "approve-modal",
          showHeader: true,
          visible: _ctx.showModal,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showModal) = $event)),
          breakpoints: { '960px': '75vw', '640px': '90vw' },
          style: { width: '40vw' },
          modal: true,
          contentClass: "wrap-ctn-modal-default"
        }, _createSlots({
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_Button, {
                class: "btn-back mr-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeDialog()))
              }, {
                default: _withCtx(() => [
                  _hoisted_51
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "btn-primary mb-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit()))
              }, {
                default: _withCtx(() => [
                  _hoisted_52
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            (_ctx.dataSource)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.dataSource.RosterCode ?? '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", null, [
                          _hoisted_10,
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.moment(_ctx.dataSource.RosterDate).format('DD MMMM YYYY')), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.dataSource.CondecturName ?? '-'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_14,
                          _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.dataSource.DriverName ?? '-'), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_16,
                          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.dataSource.VehicleRegNumber ?? '-'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          (_ctx.dataSource.Rits.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.dataSource.Rits[0].RouteName), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.dataSource.Rits.length > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.dataSource.Rits[_ctx.dataSource.Rits.length - 1].RouteName), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_Button, {
                          class: "btn-back mr-2",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printClosedStat(_ctx.dataSource)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_31
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_Card, { class: "border-grey-lighten-4 px-4 pt-4 mb-4" }, {
                        header: _withCtx(() => [
                          _hoisted_32
                        ]),
                        content: _withCtx(() => [
                          (_ctx.dataSource.Rits.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSource.Rits, (data) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: data.Id,
                                    class: "grid grid-cols-3 gap-4 border-top-grey-lighten-5 py-3 px-2"
                                  }, [
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(data.RouteName), 1),
                                    _createElementVNode("div", _hoisted_35, _toDisplayString(`${_ctx.moment(data.StartDate.toString()).format('DD MMMM YYYY')} at
                                            ${_ctx.moment(data.StartDate.toString()).format('HH.mm')}`), 1),
                                    _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.currencyNumberFormat(data.TotalTicketAmount)), 1)
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_37, "- Tidak ada data -"))
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_Card, { class: "border-grey-lighten-4 px-4 pt-4 mb-4" }, {
                        header: _withCtx(() => [
                          _hoisted_38
                        ]),
                        content: _withCtx(() => [
                          _createElementVNode("div", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.currencyNumberFormat(_ctx.dataSource.TotalTicketPpAmount)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("div", _hoisted_44, [
                              _hoisted_45,
                              _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.currencyNumberFormat(_ctx.expensetemp)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.currencyNumberFormat(_ctx.dataSource.TotalTicketPpAmount -
                    _ctx.expensetemp)), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (_ctx.dataSource)
            ? {
                name: "header",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.dataSource.TrxId), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("i", {
                        class: "pi pi-times cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDialog()))
                      })
                    ])
                  ])
                ])
              }
            : undefined
        ]), 1032, ["visible"])
      ]))
    : _createCommentVNode("", true)
}